const getdata='get_data'
const loaddata = 'load_data'
const error = 'error_data'
export{getdata,loaddata,error}